/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateServiceAgreementRequest,
  CreateServiceAgreementResponse,
  GetServiceAgreementListRequest,
  GetServiceAgreementListResponse,
  GetServiceAgreementTreeResponse,
  ProductHistoryResponse,
  ServiceAgreementContactNotesResponse,
  ServiceAgreementModificationInformationResponse,
  ServiceAgreementModificationRequest,
  ServiceAgreementV2,
  ServiceAgreementsClosingRequest,
} from '../models/index';
import {
    CreateServiceAgreementRequestFromJSON,
    CreateServiceAgreementRequestToJSON,
    CreateServiceAgreementResponseFromJSON,
    CreateServiceAgreementResponseToJSON,
    GetServiceAgreementListRequestFromJSON,
    GetServiceAgreementListRequestToJSON,
    GetServiceAgreementListResponseFromJSON,
    GetServiceAgreementListResponseToJSON,
    GetServiceAgreementTreeResponseFromJSON,
    GetServiceAgreementTreeResponseToJSON,
    ProductHistoryResponseFromJSON,
    ProductHistoryResponseToJSON,
    ServiceAgreementContactNotesResponseFromJSON,
    ServiceAgreementContactNotesResponseToJSON,
    ServiceAgreementModificationInformationResponseFromJSON,
    ServiceAgreementModificationInformationResponseToJSON,
    ServiceAgreementModificationRequestFromJSON,
    ServiceAgreementModificationRequestToJSON,
    ServiceAgreementV2FromJSON,
    ServiceAgreementV2ToJSON,
    ServiceAgreementsClosingRequestFromJSON,
    ServiceAgreementsClosingRequestToJSON,
} from '../models/index';

export interface AbortServiceAgreementModificationRequest {
    serviceAgreementUid: string;
}

export interface CloseServiceAgreementRequest {
    brUid: string;
    serviceAgreementsClosingRequest: ServiceAgreementsClosingRequest;
    closureDate?: Date;
    isBulk?: boolean;
}

export interface CreateServiceAgreementOperationRequest {
    createServiceAgreementRequest: CreateServiceAgreementRequest;
    businessRelationUid?: string;
    partnerUid?: string;
}

export interface DeactivateWealthPlanningServiceRequest {
    serviceAgreementUid: string;
    brUid: string;
}

export interface GetDocumentBinaryByIdRequest {
    serviceAgreementUid: string;
    documentId: string;
}

export interface GetPcdDocumentIdByIdRequest {
    serviceAgreementUid: string;
    documentId: string;
}

export interface GetServiceAgreementRequest {
    serviceAgreementUid?: string;
    processInstanceId?: string;
}

export interface GetServiceAgreementContactNotesRequest {
    serviceAgreementUid: string;
}

export interface GetServiceAgreementHistoryRequest {
    serviceAgreementUid: string;
}

export interface GetServiceAgreementListOperationRequest {
    getServiceAgreementListRequest: GetServiceAgreementListRequest;
}

export interface GetServiceAgreementModificationInfoRequest {
    serviceAgreementUid: string;
}

export interface GetServiceAgreementTreeRequest {
    partnerUid?: string;
    businessRelationUid?: string;
}

export interface GetServiceAgreementsRequest {
    partnerUid?: string;
    businessRelationUid?: string;
}

export interface StartServiceAgreementModificationRequest {
    serviceAgreementUid: string;
    serviceAgreementModificationRequest: ServiceAgreementModificationRequest;
}

export interface UpdateServiceAgreementRequest {
    serviceAgreementUid: string;
    serviceAgreementV2: ServiceAgreementV2;
}

export interface UploadDocumentForServiceAgreementRequest {
    serviceAgreementId: string;
    file?: Blob;
    language?: UploadDocumentForServiceAgreementLanguageEnum;
    formCode?: string;
}

/**
 * 
 */
export class ServiceAgreementApi extends runtime.BaseAPI {

    /**
     * Creates request options for abortServiceAgreementModification without sending the request
     */
    async abortServiceAgreementModificationRequestOpts(requestParameters: AbortServiceAgreementModificationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling abortServiceAgreementModification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceAgreement/{serviceAgreementUid}/modify`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Aborts a Service Agreement\'s modification process that is currently in progress
     * Abort service agreement modification
     */
    async abortServiceAgreementModificationRaw(requestParameters: AbortServiceAgreementModificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceAgreementV2>> {
        const requestOptions = await this.abortServiceAgreementModificationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceAgreementV2FromJSON(jsonValue));
    }

    /**
     * Aborts a Service Agreement\'s modification process that is currently in progress
     * Abort service agreement modification
     */
    async abortServiceAgreementModification(requestParameters: AbortServiceAgreementModificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceAgreementV2> {
        const response = await this.abortServiceAgreementModificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for closeServiceAgreement without sending the request
     */
    async closeServiceAgreementRequestOpts(requestParameters: CloseServiceAgreementRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brUid'] == null) {
            throw new runtime.RequiredError(
                'brUid',
                'Required parameter "brUid" was null or undefined when calling closeServiceAgreement().'
            );
        }

        if (requestParameters['serviceAgreementsClosingRequest'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementsClosingRequest',
                'Required parameter "serviceAgreementsClosingRequest" was null or undefined when calling closeServiceAgreement().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['closureDate'] != null) {
            queryParameters['closureDate'] = (requestParameters['closureDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['isBulk'] != null) {
            queryParameters['isBulk'] = requestParameters['isBulk'];
        }

        if (requestParameters['brUid'] != null) {
            queryParameters['brUid'] = requestParameters['brUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/serviceAgreement/close`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ServiceAgreementsClosingRequestToJSON(requestParameters['serviceAgreementsClosingRequest']),
        };
    }

    /**
     * Close service agreements (included workflow instances)
     * Close service agreements
     */
    async closeServiceAgreementRaw(requestParameters: CloseServiceAgreementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.closeServiceAgreementRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Close service agreements (included workflow instances)
     * Close service agreements
     */
    async closeServiceAgreement(requestParameters: CloseServiceAgreementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.closeServiceAgreementRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for createServiceAgreement without sending the request
     */
    async createServiceAgreementRequestOpts(requestParameters: CreateServiceAgreementOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createServiceAgreementRequest'] == null) {
            throw new runtime.RequiredError(
                'createServiceAgreementRequest',
                'Required parameter "createServiceAgreementRequest" was null or undefined when calling createServiceAgreement().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['businessRelationUid'] != null) {
            queryParameters['businessRelationUid'] = requestParameters['businessRelationUid'];
        }

        if (requestParameters['partnerUid'] != null) {
            queryParameters['partnerUid'] = requestParameters['partnerUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/serviceAgreement/create`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateServiceAgreementRequestToJSON(requestParameters['createServiceAgreementRequest']),
        };
    }

    /**
     * Create new service agreement (included workflow instance). For an ACTIVE PRIVATE_BANKING business relation the request must carry at least one contact note UID in `contactNoteUids`; otherwise creation is rejected with 403. 
     * Create service agreement
     */
    async createServiceAgreementRaw(requestParameters: CreateServiceAgreementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateServiceAgreementResponse>> {
        const requestOptions = await this.createServiceAgreementRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateServiceAgreementResponseFromJSON(jsonValue));
    }

    /**
     * Create new service agreement (included workflow instance). For an ACTIVE PRIVATE_BANKING business relation the request must carry at least one contact note UID in `contactNoteUids`; otherwise creation is rejected with 403. 
     * Create service agreement
     */
    async createServiceAgreement(requestParameters: CreateServiceAgreementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateServiceAgreementResponse> {
        const response = await this.createServiceAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deactivateWealthPlanningService without sending the request
     */
    async deactivateWealthPlanningServiceRequestOpts(requestParameters: DeactivateWealthPlanningServiceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling deactivateWealthPlanningService().'
            );
        }

        if (requestParameters['brUid'] == null) {
            throw new runtime.RequiredError(
                'brUid',
                'Required parameter "brUid" was null or undefined when calling deactivateWealthPlanningService().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['serviceAgreementUid'] != null) {
            queryParameters['serviceAgreementUid'] = requestParameters['serviceAgreementUid'];
        }

        if (requestParameters['brUid'] != null) {
            queryParameters['brUid'] = requestParameters['brUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceAgreement/deactivate-wealth-planning`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Close a wealth planning, active referral (WP) or active referral (RM) service agreement without waiting for any external confirmation. An ACTIVE agreement becomes INACTIVE; a READY_FOR_CONFIGURATION agreement is withdrawn. The operation id keeps its wealth-planning name to avoid regenerating clients.
     * Deactivate wealth planning or active referral service
     */
    async deactivateWealthPlanningServiceRaw(requestParameters: DeactivateWealthPlanningServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deactivateWealthPlanningServiceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Close a wealth planning, active referral (WP) or active referral (RM) service agreement without waiting for any external confirmation. An ACTIVE agreement becomes INACTIVE; a READY_FOR_CONFIGURATION agreement is withdrawn. The operation id keeps its wealth-planning name to avoid regenerating clients.
     * Deactivate wealth planning or active referral service
     */
    async deactivateWealthPlanningService(requestParameters: DeactivateWealthPlanningServiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deactivateWealthPlanningServiceRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getDocumentBinaryById without sending the request
     */
    async getDocumentBinaryByIdRequestOpts(requestParameters: GetDocumentBinaryByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling getDocumentBinaryById().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getDocumentBinaryById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceAgreement/{serviceAgreementUid}/document/{documentId}/binary`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Return binary file for the given document id
     * Return binary file for the given document id
     */
    async getDocumentBinaryByIdRaw(requestParameters: GetDocumentBinaryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.getDocumentBinaryByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Return binary file for the given document id
     * Return binary file for the given document id
     */
    async getDocumentBinaryById(requestParameters: GetDocumentBinaryByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getDocumentBinaryByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPcdDocumentIdById without sending the request
     */
    async getPcdDocumentIdByIdRequestOpts(requestParameters: GetPcdDocumentIdByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling getPcdDocumentIdById().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getPcdDocumentIdById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceAgreement/{serviceAgreementUid}/document/{documentId}`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Return pcd document id for redirection
     * Return pcd document id for redirection
     */
    async getPcdDocumentIdByIdRaw(requestParameters: GetPcdDocumentIdByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.getPcdDocumentIdByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Return pcd document id for redirection
     * Return pcd document id for redirection
     */
    async getPcdDocumentIdById(requestParameters: GetPcdDocumentIdByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getPcdDocumentIdByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getServiceAgreement without sending the request
     */
    async getServiceAgreementRequestOpts(requestParameters: GetServiceAgreementRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['serviceAgreementUid'] != null) {
            queryParameters['serviceAgreementUid'] = requestParameters['serviceAgreementUid'];
        }

        if (requestParameters['processInstanceId'] != null) {
            queryParameters['processInstanceId'] = requestParameters['processInstanceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceAgreement`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a service agreement object
     * Get existing service agreement
     */
    async getServiceAgreementRaw(requestParameters: GetServiceAgreementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceAgreementV2>> {
        const requestOptions = await this.getServiceAgreementRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceAgreementV2FromJSON(jsonValue));
    }

    /**
     * Returns a service agreement object
     * Get existing service agreement
     */
    async getServiceAgreement(requestParameters: GetServiceAgreementRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceAgreementV2> {
        const response = await this.getServiceAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getServiceAgreementContactNotes without sending the request
     */
    async getServiceAgreementContactNotesRequestOpts(requestParameters: GetServiceAgreementContactNotesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling getServiceAgreementContactNotes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceAgreement/{serviceAgreementUid}/contact-notes`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns contact notes associated with the specified service agreement. For Service Model (SERVICE_MODEL) agreements: if a DRAFT Service Model Agreement exists, its contact notes are returned (empty when the draft has none); otherwise Active SMA notes; otherwise an empty list. For other products, returns all notes linked to the service agreement. 
     * Get contact notes for a service agreement
     */
    async getServiceAgreementContactNotesRaw(requestParameters: GetServiceAgreementContactNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceAgreementContactNotesResponse>> {
        const requestOptions = await this.getServiceAgreementContactNotesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceAgreementContactNotesResponseFromJSON(jsonValue));
    }

    /**
     * Returns contact notes associated with the specified service agreement. For Service Model (SERVICE_MODEL) agreements: if a DRAFT Service Model Agreement exists, its contact notes are returned (empty when the draft has none); otherwise Active SMA notes; otherwise an empty list. For other products, returns all notes linked to the service agreement. 
     * Get contact notes for a service agreement
     */
    async getServiceAgreementContactNotes(requestParameters: GetServiceAgreementContactNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceAgreementContactNotesResponse> {
        const response = await this.getServiceAgreementContactNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getServiceAgreementHistory without sending the request
     */
    async getServiceAgreementHistoryRequestOpts(requestParameters: GetServiceAgreementHistoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling getServiceAgreementHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceAgreement/{serviceAgreementUid}/history`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the product status change history for a given service agreement. Used to populate the Product Review table on the UI. 
     * Get service agreement review history
     */
    async getServiceAgreementHistoryRaw(requestParameters: GetServiceAgreementHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductHistoryResponse>> {
        const requestOptions = await this.getServiceAgreementHistoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Returns the product status change history for a given service agreement. Used to populate the Product Review table on the UI. 
     * Get service agreement review history
     */
    async getServiceAgreementHistory(requestParameters: GetServiceAgreementHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductHistoryResponse> {
        const response = await this.getServiceAgreementHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getServiceAgreementList without sending the request
     */
    async getServiceAgreementListRequestOpts(requestParameters: GetServiceAgreementListOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['getServiceAgreementListRequest'] == null) {
            throw new runtime.RequiredError(
                'getServiceAgreementListRequest',
                'Required parameter "getServiceAgreementListRequest" was null or undefined when calling getServiceAgreementList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/serviceAgreement/search`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetServiceAgreementListRequestToJSON(requestParameters['getServiceAgreementListRequest']),
        };
    }

    /**
     * Returns service agreements with SERVICE_VERSION = 1 (legacy products such as DAC, BOI, etc.). Used by the Accounts view (/accounts/{brId}) for intermediary business relations. For V2 products (e.g. Alternative Investment), use GET /serviceAgreement/list instead. 
     * Get V1 (legacy) service agreements for a specific partner/BR
     */
    async getServiceAgreementListRaw(requestParameters: GetServiceAgreementListOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetServiceAgreementListResponse>> {
        const requestOptions = await this.getServiceAgreementListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetServiceAgreementListResponseFromJSON(jsonValue));
    }

    /**
     * Returns service agreements with SERVICE_VERSION = 1 (legacy products such as DAC, BOI, etc.). Used by the Accounts view (/accounts/{brId}) for intermediary business relations. For V2 products (e.g. Alternative Investment), use GET /serviceAgreement/list instead. 
     * Get V1 (legacy) service agreements for a specific partner/BR
     */
    async getServiceAgreementList(requestParameters: GetServiceAgreementListOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetServiceAgreementListResponse> {
        const response = await this.getServiceAgreementListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getServiceAgreementModificationInfo without sending the request
     */
    async getServiceAgreementModificationInfoRequestOpts(requestParameters: GetServiceAgreementModificationInfoRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling getServiceAgreementModificationInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceAgreement/{serviceAgreementUid}/modify`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns required information in order to proceed with service agreement modification
     * Get service agreement modification informations
     */
    async getServiceAgreementModificationInfoRaw(requestParameters: GetServiceAgreementModificationInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceAgreementModificationInformationResponse>> {
        const requestOptions = await this.getServiceAgreementModificationInfoRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceAgreementModificationInformationResponseFromJSON(jsonValue));
    }

    /**
     * Returns required information in order to proceed with service agreement modification
     * Get service agreement modification informations
     */
    async getServiceAgreementModificationInfo(requestParameters: GetServiceAgreementModificationInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceAgreementModificationInformationResponse> {
        const response = await this.getServiceAgreementModificationInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getServiceAgreementTree without sending the request
     */
    async getServiceAgreementTreeRequestOpts(requestParameters: GetServiceAgreementTreeRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['partnerUid'] != null) {
            queryParameters['partnerUid'] = requestParameters['partnerUid'];
        }

        if (requestParameters['businessRelationUid'] != null) {
            queryParameters['businessRelationUid'] = requestParameters['businessRelationUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceAgreement/tree`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns service agreements with SERVICE_VERSION = 2 (new products such as Alternative Investment). Used by the Private Banking view (/private-banking/{brUuid}). For V1 legacy products (DAC, BOI, etc.), use POST /serviceAgreement/search instead. 
     * Get V2 (new) service agreements as tree by optional filters
     */
    async getServiceAgreementTreeRaw(requestParameters: GetServiceAgreementTreeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetServiceAgreementTreeResponse>> {
        const requestOptions = await this.getServiceAgreementTreeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetServiceAgreementTreeResponseFromJSON(jsonValue));
    }

    /**
     * Returns service agreements with SERVICE_VERSION = 2 (new products such as Alternative Investment). Used by the Private Banking view (/private-banking/{brUuid}). For V1 legacy products (DAC, BOI, etc.), use POST /serviceAgreement/search instead. 
     * Get V2 (new) service agreements as tree by optional filters
     */
    async getServiceAgreementTree(requestParameters: GetServiceAgreementTreeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetServiceAgreementTreeResponse> {
        const response = await this.getServiceAgreementTreeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getServiceAgreements without sending the request
     */
    async getServiceAgreementsRequestOpts(requestParameters: GetServiceAgreementsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['partnerUid'] != null) {
            queryParameters['partnerUid'] = requestParameters['partnerUid'];
        }

        if (requestParameters['businessRelationUid'] != null) {
            queryParameters['businessRelationUid'] = requestParameters['businessRelationUid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceAgreement/list`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns service agreements with SERVICE_VERSION = 2 (new products such as Alternative Investment). Used by the Private Banking view (/private-banking/{brUuid}). For V1 legacy products (DAC, BOI, etc.), use POST /serviceAgreement/search instead. 
     * Get V2 (new) service agreements by optional filters
     */
    async getServiceAgreementsRaw(requestParameters: GetServiceAgreementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetServiceAgreementListResponse>> {
        const requestOptions = await this.getServiceAgreementsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetServiceAgreementListResponseFromJSON(jsonValue));
    }

    /**
     * Returns service agreements with SERVICE_VERSION = 2 (new products such as Alternative Investment). Used by the Private Banking view (/private-banking/{brUuid}). For V1 legacy products (DAC, BOI, etc.), use POST /serviceAgreement/search instead. 
     * Get V2 (new) service agreements by optional filters
     */
    async getServiceAgreements(requestParameters: GetServiceAgreementsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetServiceAgreementListResponse> {
        const response = await this.getServiceAgreementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for startServiceAgreementModification without sending the request
     */
    async startServiceAgreementModificationRequestOpts(requestParameters: StartServiceAgreementModificationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling startServiceAgreementModification().'
            );
        }

        if (requestParameters['serviceAgreementModificationRequest'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementModificationRequest',
                'Required parameter "serviceAgreementModificationRequest" was null or undefined when calling startServiceAgreementModification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/serviceAgreement/{serviceAgreementUid}/modify`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ServiceAgreementModificationRequestToJSON(requestParameters['serviceAgreementModificationRequest']),
        };
    }

    /**
     * Returns updated service agreement
     * Start service agreement modification
     */
    async startServiceAgreementModificationRaw(requestParameters: StartServiceAgreementModificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceAgreementV2>> {
        const requestOptions = await this.startServiceAgreementModificationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceAgreementV2FromJSON(jsonValue));
    }

    /**
     * Returns updated service agreement
     * Start service agreement modification
     */
    async startServiceAgreementModification(requestParameters: StartServiceAgreementModificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceAgreementV2> {
        const response = await this.startServiceAgreementModificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateServiceAgreement without sending the request
     */
    async updateServiceAgreementRequestOpts(requestParameters: UpdateServiceAgreementRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling updateServiceAgreement().'
            );
        }

        if (requestParameters['serviceAgreementV2'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementV2',
                'Required parameter "serviceAgreementV2" was null or undefined when calling updateServiceAgreement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/serviceAgreement/{serviceAgreementUid}/update`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ServiceAgreementV2ToJSON(requestParameters['serviceAgreementV2']),
        };
    }

    /**
     * Returns updated service agreement object
     * Update existing service agreement
     */
    async updateServiceAgreementRaw(requestParameters: UpdateServiceAgreementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceAgreementV2>> {
        const requestOptions = await this.updateServiceAgreementRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceAgreementV2FromJSON(jsonValue));
    }

    /**
     * Returns updated service agreement object
     * Update existing service agreement
     */
    async updateServiceAgreement(requestParameters: UpdateServiceAgreementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceAgreementV2> {
        const response = await this.updateServiceAgreementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uploadDocumentForServiceAgreement without sending the request
     */
    async uploadDocumentForServiceAgreementRequestOpts(requestParameters: UploadDocumentForServiceAgreementRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementId'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementId',
                'Required parameter "serviceAgreementId" was null or undefined when calling uploadDocumentForServiceAgreement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['language'] != null) {
            formParams.append('language', requestParameters['language'] as any);
        }

        if (requestParameters['formCode'] != null) {
            formParams.append('formCode', requestParameters['formCode'] as any);
        }


        let urlPath = `/serviceAgreement/upload/{serviceAgreementId}`;
        urlPath = urlPath.replace(`{${"serviceAgreementId"}}`, encodeURIComponent(String(requestParameters['serviceAgreementId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     * Provides the upload of a document related with the service agreement specified by the {serviceAgreementId}
     * Provides the upload of a document related with the service agreement
     */
    async uploadDocumentForServiceAgreementRaw(requestParameters: UploadDocumentForServiceAgreementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uploadDocumentForServiceAgreementRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Provides the upload of a document related with the service agreement specified by the {serviceAgreementId}
     * Provides the upload of a document related with the service agreement
     */
    async uploadDocumentForServiceAgreement(requestParameters: UploadDocumentForServiceAgreementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadDocumentForServiceAgreementRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const UploadDocumentForServiceAgreementLanguageEnum = {
    En: 'EN',
    De: 'DE',
    Fr: 'FR',
    It: 'IT',
    Es: 'ES'
} as const;
export type UploadDocumentForServiceAgreementLanguageEnum = typeof UploadDocumentForServiceAgreementLanguageEnum[keyof typeof UploadDocumentForServiceAgreementLanguageEnum];
